import "./Category.scss"
import React from 'react';
export default function Category({CategoryName: categoryName}){
  return(
    <div className="categoryContainer">
      <p className="text">{categoryName}</p>
    </div>
  )
}